import { Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { RequireAuth } from "./auth/RequireAuth";
import { RequireModules } from "./auth/RequireModules";
import { RequirePlatformRole } from "./auth/RequirePlatformRole";
import { AssistancePage } from "./pages/AssistancePage";
import { AssetExpensesPage } from "./pages/AssetExpensesPage";
import { AssetOperationPage } from "./pages/AssetOperationPage";
import { AssetsPage } from "./pages/AssetsPage";
import { CommissionsPage } from "./pages/CommissionsPage";
import { ContractsPage } from "./pages/ContractsPage";
import { CustomersPage } from "./pages/CustomersPage";
import { DashboardPage } from "./pages/DashboardPage";
import { Customer360Page } from "./pages/Customer360Page";
import { DocumentBuilderPage } from "./pages/DocumentBuilderPage";
import { ImportCenterPage } from "./pages/ImportCenterPage";
import { NotificationsPage } from "./pages/NotificationsPage";
import { ProductFactoryPage } from "./pages/ProductFactoryPage";
import { SaaSBillingPage } from "./pages/SaaSBillingPage";
import { SupportConsolePage } from "./pages/SupportConsolePage";
import { TenantFactoryPage } from "./pages/TenantFactoryPage";
import { WorkflowsPage } from "./pages/WorkflowsPage";
import { FinancePage } from "./pages/FinancePage";
import { IntegrationsPage } from "./pages/IntegrationsPage";
import { LoginPage } from "./pages/LoginPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { OnboardingPage } from "./pages/OnboardingPage";
import { PlatformTenantsPage } from "./pages/PlatformTenantsPage";
import { PortalPage } from "./pages/PortalPage";
import { ProductsPage } from "./pages/ProductsPage";
import { PropertyLeasesPage } from "./pages/PropertyLeasesPage";
import { PublicSecondCopyPage } from "./pages/PublicSecondCopyPage";
import { ReceivablesPage } from "./pages/ReceivablesPage";
import { SalesPage } from "./pages/SalesPage";
import { SettingsPage } from "./pages/SettingsPage";
import { TelemedicinePage } from "./pages/TelemedicinePage";
import { TeamPage } from "./pages/TeamPage";
import { VehicleRentalsPage } from "./pages/VehicleRentalsPage";
import { VehicleSalesPage } from "./pages/VehicleSalesPage";
import { SoftwareContractsPage } from "./pages/SoftwareContractsPage";

function BackofficeRoutes() {
  return (
    <RequireAuth>
      <AppShell>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/clientes" element={<CustomersPage />} />
          <Route path="/clientes/:id" element={<Customer360Page />} />
          <Route path="/vendas" element={<SalesPage />} />
          <Route path="/equipe" element={<TeamPage />} />
          <Route path="/produtos" element={<ProductsPage />} />
          <Route path="/contratos" element={<ContractsPage />} />
          <Route path="/financeiro" element={<FinancePage />} />
          <Route path="/comissoes" element={<CommissionsPage />} />
          <Route path="/telemedicina" element={<TelemedicinePage />} />
          <Route path="/assistencia" element={<AssistancePage />} />
          <Route
            path="/assistencia-funeraria"
            element={
              <RequireModules modules={["funeral_assistance"]}>
                <AssistancePage funeralOnly />
              </RequireModules>
            }
          />
          <Route
            path="/contratos-software"
            element={
              <RequireModules modules={["software_contracts"]}>
                <SoftwareContractsPage />
              </RequireModules>
            }
          />
          <Route
            path="/patrimonio"
            element={
              <RequireModules modules={["assets"]}>
                <AssetsPage />
              </RequireModules>
            }
          />
          <Route
            path="/vendas-veiculos"
            element={
              <RequireModules modules={["vehicle_sales"]}>
                <VehicleSalesPage />
              </RequireModules>
            }
          />
          <Route
            path="/locacoes-imoveis"
            element={
              <RequireModules modules={["property_leases"]}>
                <PropertyLeasesPage />
              </RequireModules>
            }
          />
          <Route
            path="/locacoes-veiculos"
            element={
              <RequireModules modules={["vehicle_rentals"]}>
                <VehicleRentalsPage />
              </RequireModules>
            }
          />
          <Route
            path="/despesas-ativos"
            element={
              <RequireModules modules={["asset_expenses"]}>
                <AssetExpensesPage />
              </RequireModules>
            }
          />
          <Route
            path="/recebiveis"
            element={
              <RequireModules modules={["receivable_schedules"]}>
                <ReceivablesPage />
              </RequireModules>
            }
          />
          <Route
            path="/operacoes/nova"
            element={
              <RequireModules modules={["assets"]}>
                <AssetOperationPage />
              </RequireModules>
            }
          />
          <Route path="/integracoes" element={<IntegrationsPage />} />
          <Route path="/configuracoes" element={<SettingsPage />} />
          <Route path="/workflows" element={<WorkflowsPage />} />
          <Route path="/notificacoes" element={<NotificationsPage />} />
          <Route path="/modelos-documentos" element={<DocumentBuilderPage />} />
          <Route path="/importacoes" element={<ImportCenterPage />} />
          <Route path="/fabrica-produto" element={<ProductFactoryPage />} />
          <Route
            path="/yatta"
            element={
              <RequirePlatformRole>
                <PlatformTenantsPage />
              </RequirePlatformRole>
            }
          />
          <Route
            path="/yatta/suporte"
            element={
              <RequirePlatformRole>
                <SupportConsolePage />
              </RequirePlatformRole>
            }
          />
          <Route
            path="/yatta/fabrica"
            element={
              <RequirePlatformRole>
                <TenantFactoryPage />
              </RequirePlatformRole>
            }
          />
          <Route
            path="/yatta/faturamento"
            element={
              <RequirePlatformRole>
                <SaaSBillingPage />
              </RequirePlatformRole>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AppShell>
    </RequireAuth>
  );
}

export function App() {
  const location = useLocation();

  if (location.pathname.startsWith("/onboarding")) {
    return (
      <Routes>
        <Route path="/onboarding/:id?" element={<OnboardingPage />} />
      </Routes>
    );
  }
  if (location.pathname.startsWith("/portal")) {
    return (
      <Routes>
        <Route path="/portal" element={<PortalPage />} />
      </Routes>
    );
  }
  if (location.pathname.startsWith("/segunda-via")) {
    return (
      <Routes>
        <Route path="/segunda-via" element={<PublicSecondCopyPage />} />
      </Routes>
    );
  }
  if (location.pathname === "/login") {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
      </Routes>
    );
  }
  return <BackofficeRoutes />;
}
